import { Component } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { filter } from 'rxjs';

@Component({
  selector: 'app-language-modal',
  standalone: true,
  imports: [],
  templateUrl: './language-modal.component.html',
  styleUrl: './language-modal.component.css',
})
export class LanguageModalComponent {
  currentLanguage = 'en';
  currentLanguageView = 'English';

  isModalOpen = false;
  languages = [
    { name: 'English', value: 'en' },
    { name: 'Русский', value: 'ru' },
    { name: 'Español', value: 'es' },
    { name: 'Français', value: 'fr' },
    { name: 'Deutsch', value: 'de' },
  ];

  constructor(
    private router: Router,
    public translate: TranslateService,
    private route: ActivatedRoute
  ) {
    this.router.events
      .pipe(
        filter((ev) => ev instanceof NavigationEnd),
        takeUntilDestroyed()
      )
      .subscribe(({ urlAfterRedirects }) => {
        const languageMatch = urlAfterRedirects.match(/(ru|es|fr|de)/);
        if (languageMatch && languageMatch[1]) {
          this.currentLanguage = languageMatch[1];
          this.currentLanguageView =
            this.languages.find((lang) => lang.value === this.currentLanguage)
              ?.name ?? 'English';
        } else {
          this.currentLanguage = 'en';
          this.currentLanguageView = 'English';
        }
      });
  }

  openModal($event: MouseEvent) {
    $event.preventDefault();

    this.isModalOpen = true;
  }

  closeModal() {
    this.isModalOpen = false;
  }

  selectLanguage(language: { name: string; value: string }) {
    let url = this.router.url;

    const languageMatch = url.match(/\/(ru|es|fr|de)\//);

    if (language.value === 'en') {
      if (languageMatch) {
        url = url.replace(/\/(en|ru|es|fr|de)/, '');
      }
    } else {
      if (languageMatch) {
        url = url.replace(/\/(en|ru|es|fr|de)\//, `/${language.value}/`);
      } else {
        url = `/${language.value}${url}`;
      }
    }

    this.currentLanguage = language.value;

    this.currentLanguageView =
      this.languages.find((lang) => lang.value === this.currentLanguage)
        ?.name ?? 'English';

    this.router.navigateByUrl(url);
    this.closeModal();
  }

  onBackdropClick(event: Event) {
    if (event.target === event.currentTarget) {
      this.closeModal();
    }
  }
}
